import { buildFieldSurfaceStyleFromKiot, type FieldSurfaceDefaults, type FieldSurfaceStyle } from './types'

/**
 * Base ô nhập cột 2 POS — chỉ gạch chân, không hộp viền.
 * Chuẩn Bán giao hàng; dùng chung Bán nhanh / Bán thường / trả hàng POS.
 */
const base = buildFieldSurfaceStyleFromKiot()

export const POS_UNDERLINE_FIELD_SURFACE_STYLE: FieldSurfaceStyle = {
  ...base,
  inputChrome: 'underline',
  labelFontSizePx: 15,
  labelFontWeight: 500,
  labelColor: '#15171a',
  inputFontSizePx: 15,
  inputFontWeight: 400,
  inputColor: '#000000',
  placeholderColor: '#6b7280',
  inputHeightPx: 40,
  borderRadiusPx: 0,
  inputPaddingX: 2,
  inputBg: 'transparent',
  inputBgDisabled: 'transparent',
  borderColor: '#e0e0e0',
  borderHover: '#bdbdbd',
  focusColor: '#0070f4',
  focusShadow: 'none',
  labelGapPx: 0,
  surfaceBg: '#ffffff',
}

export const POS_UNDERLINE_FIELD_SURFACE_DEFAULTS: FieldSurfaceDefaults = {
  labelLayout: 'above',
  size: 'small',
  variant: 'outlined',
  fullWidth: true,
  useLabelAsPlaceholder: true,
}
